"use client";
import type { Countries } from "@/queries/getCountries";
import type { Departure, Travel } from "services/travel";
import { SecondaryButton } from "ui/components";
import { DownloadIcon, ProgrammeIcon } from "ui/iconsN";
import { RequestProgram } from "../RequestProgram";
import { requestProgrammeOnSuccessServer } from "../RequestProgram/requestProgrammeOnSuccessServer";
import { InfosupBook } from "./InfosupBook";
import { InfosupBookHemerys } from "./InfosupBookHemerys";

type Props = {
  travel: Travel;
  departure: Departure;
  countries: Countries;
};
export const RequestProgramBookSection = ({ travel, countries, departure }: Props) => {
  const isHemerys = travel.brandCustomerTitle === "Hémérys";
  const requestProgramProps = {
    travelId: travel.id,
    isAvailable: departure.state.versionStatus !== "soon",
    versionId: departure.versionId,
    departureId: departure.id,
    onSuccess: () => requestProgrammeOnSuccessServer(travel, departure),
    countries,
    travelTitle: travel.title,
    travelImage: travel.travelImages[0] || null,
    departure,
    travelCountries: travel.countries,
    source: "after_program",
  } as const;

  return (
    <div className="relative my-10 max-sm:mt-[100px] lg:my-16 rounded-xl border border-pr-1 bg-[#F8EEEB] p-6 max-sm:flex max-sm:flex-col max-sm:gap-6 sm:py-6 sm:pr-6 sm:pl-[200px]">
      <RequestProgram
        {...requestProgramProps}
        className="group/book relative -rotate-3 cursor-pointer transition-transform duration-300 hover:rotate-0 max-sm:-mt-[100px] max-sm:self-center sm:absolute sm:-left-4 sm:top-1/2 sm:-translate-y-1/2"
      >
        {isHemerys ? (
          <InfosupBookHemerys
            travelId={travel.id}
            travelTitle={travel.title}
            travelImage={travel.travelImages[0] || null}
            dateStart={departure.dateStart}
            dateEnd={departure.dateEnd}
            countries={travel.countries}
          />
        ) : (
          <InfosupBook
            travelId={travel.id}
            travelTitle={travel.title}
            travelImage={travel.travelImages[0] || null}
            dateStart={departure.dateStart}
            dateEnd={departure.dateEnd}
            countries={travel.countries}
          />
        )}
        <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover/book:opacity-100">
          <div className="absolute inset-0 rounded-l-[2px] rounded-r-[6px] bg-[#31241E]/10 blur-[2.5px]" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[32px] border border-bg-2 bg-bg-1 p-3">
            <DownloadIcon className="size-6 text-pr-1" />
          </div>
        </div>
      </RequestProgram>
      <div className="flex flex-col items-start gap-[13px]">
        <p className="text-2xl font-semibold text-tx-1">Téléchargez l’itinéraire complet</p>
        <p className="text-base/6 text-tx-1">
          Accédez à tous les détails de votre voyage en un seul document : itinéraire, infos pratiques, activités et
          bien plus encore. Ne manquez rien de votre prochaine aventure{"\u00A0"}!
        </p>
        <RequestProgram {...requestProgramProps}>
          <SecondaryButton>
            <ProgrammeIcon className="h-4 w-4 text-pr-1" />
            Télécharger l’itinéraire complet
          </SecondaryButton>
        </RequestProgram>
      </div>
    </div>
  );
};
